import { render, staticRenderFns } from "./InteractiveManage.vue?vue&type=template&id=5385495b&scoped=true"
import script from "./InteractiveManage.vue?vue&type=script&lang=js"
export * from "./InteractiveManage.vue?vue&type=script&lang=js"
import style0 from "./InteractiveManage.vue?vue&type=style&index=0&id=5385495b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385495b",
  null
  
)

export default component.exports